// extracted by mini-css-extract-plugin
export var columnList = "_gp-0";